import { useEffect, useState } from 'react';
import axios from 'axios';
import resourceSlug from '../../../constant/resource-slug';

const useGetPaymentDetails = (paymentId) => {
  const [payment, setPayment] = useState();
  const [loading, setLoading] = useState(!!paymentId);

  const getPaymentDetails = async () => {
    try {
      setLoading(true);
      const { data } = await axios.get(`/api/${resourceSlug.PAYMENT}/${paymentId}`);

      setPayment(data.data);
    } catch (err) {
      console.error('[ERROR] Get Payment Details', err?.message);
      setPayment(undefined);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (paymentId) {
      getPaymentDetails(paymentId);
    } else {
      setPayment(undefined);
    }
  }, [paymentId]);

  return {
    payment,
    loading,
  };
};

export default useGetPaymentDetails;
